module.exports = __webpack_public_path__ + "static/media/ic_未选.f2785932.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_未选.svg
// module id = 252
// module chunks = 0